import { Component, forwardRef } from "@angular/core";
import { ModelService } from "../../../../Services/model.service";

import { StartAction } from "../../../../Model/Dto/StartAction";
import { UserActionBaseComponent } from "../userAction-base.component";
import { TranslateService } from "@ngx-translate/core";
import { CatalogService } from "app/Services/CatalogManagement/catalog.service";
import { MacroService } from "app/Services/CatalogManagement/macro.service";
import { JobService } from "app/Services/job.service";
import { LoginService } from "app/Services/login.service";
import { Macro } from "app/Model/ui/Macro";



@Component({
    selector: "userAction-createEnventaMime",
    templateUrl: "userAction-createEnventaMime.component.html",
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionCreateEnventaMimeComponent) }
    ],
    standalone: false
})
export class UserActionCreateEnventaMimeComponent extends  UserActionBaseComponent {
  postfix :string = "";
  
  constructor(public loginService: LoginService, public macroService: MacroService, public jobService: JobService, public translate: TranslateService, public catalogService: CatalogService) {
    super(loginService, macroService);
  }

  public getActionId(macro: Macro): string {
    return `CreateEnventaMime(${this.postfix})`;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({postfix:this.postfix});
  }
  public parseParameter(parameter: string) {
    throw new Error("Method not implemented.");
  }
}
